const ROLES = {
  ADM: [
    "view:profile",
    "create:profile",
    "update:profile",
    "delete:profile",

    "view:active",
    "create:active",
    "update:active",
    "delete:active",

    "view:transaction",
    "create:transaction",
    "update:transaction",
    "delete:transaction",
  ],
  CLI: ["view:profile"],
  CYG: [
    "view:profile",
    "update:profile",

    "view:active",
    "create:active",
    "update:active",
    "delete:active",

    "view:transaction",
    "create:transaction",
    "update:transaction",
    "delete:transaction",
  ],
  MOD: ["view:profile"],
  user: [
    "view:profile",
    "update:profile",
  ],
}

export const hasPermission = (user, permission) => {
  return ROLES[user.profile_type].includes(permission)
}

export const isOwnUser = (user, editUserId) => {
  return user.id == editUserId;
}